import { ApolloError, useMutation } from '@apollo/client';
import { encodeBase64URLString, generateURIParamsString, } from '@thoughtspot/codec-util';
import { GetBlobService } from '@thoughtspot/custom-style-service';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { shouldUseGetEncoding } from '@thoughtspot/system-config-service';
import _ from 'lodash';
import useFetch, { CachePolicies } from 'use-http';
import { CheckSslCertDocument, GetConfigInfoOverridesDocument, SetSslDocument, UpdateConfigInfoDocument, useDeleteHelpConfigMutation as _useDeleteHelpConfigMutation, useDeleteLdapAdIamV1Mutation as _useDeleteLdapAdIamV1Mutation, useDeleteNasMutation as _useDeleteNasMutation, useDeleteSamlIamV1Mutation as _useDeleteSamlIamV1Mutation, useDeleteSmtpMutation as _useDeleteSmtpMutation, useDeleteSnapshotMutation as _useDeleteSnapshotMutation, useDeleteSslMutation as _useDeleteSslMutation, useGetAdminAlertsQuery as _useGetAdminAlertsQuery, useGetAdminEventsQuery as _useGetAdminEventsQuery, useGetHelpConfigListQuery as _useGetHelpConfigListQuery, useGetLdapAdIamV1Query as _useGetLdapAdIamV1Query, useGetLocalIamV1Query as _useGetLocalIamV1Query, useGetNasLazyQuery as _useGetNasLazyQuery, useGetReleaseVersionQuery as _useGetReleaseVersionQuery, useGetRevSshQuery as _useGetRevSshQuery, useGetSamlIamV1Query as _useGetSamlIamV1Query, useGetSmtpQuery as _useGetSmtpQuery, useGetSnapshotLazyQuery as _useGetSnapshotLazyQuery, useGetSslQuery as _useGetSslQuery, useResetHelpConfigMutation as _useResetHelpConfigMutation, useSetEditHelpConfigMutation as _useSetEditHelpConfigMutation, useSetHelpConfigMutation as _useSetHelpConfigMutation, useSetLdapAdIamV1Mutation as _useSetLdapAdIamV1Mutation, useSetLocalIamV1Mutation as _useSetLocalIamV1Mutation, useSetNasMutation as _useSetNasMutation, useSetRevSshMutation as _useSetRevSshMutation, useSetSmtpMutation as _useSetSmtpMutation, useSetSnapshotMutation as _useSetSnapshotMutation, } from '../generated/graphql-types';
const ENCODE_BASE_PATH = envFlags.getValue(FLAGS.urlEncodingBasePath.name);
export const getIconURL = (iconFilePath) => {
    const url = GetBlobService.getBlobUrl(iconFilePath);
    return url;
};
export const useGetHelpConfigListQuery = () => {
    const { data, error, loading } = _useGetHelpConfigListQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Actions_getHelpConfig,
    };
};
export const useGetReleaseVersionQuery = () => {
    const { data, error, loading } = _useGetReleaseVersionQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Actions_getReleaseVersion,
    };
};
export const useDeleteHelpConFig = (onComplete, onError, id) => _useDeleteHelpConfigMutation({
    variables: { id },
    update: (cache, result) => {
        onComplete(result?.data.Actions_deleteHelpConfig);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetHelpConfig = (onComplete, onError, inputData) => _useSetHelpConfigMutation({
    variables: { inputData },
    update: (cache, result) => {
        onComplete(result?.data.Actions_addHelpConfig);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useEditHelpConfig = (onComplete, onError, inputData) => _useSetEditHelpConfigMutation({
    variables: { inputData },
    update: (cache, result) => {
        onComplete(result?.data.Actions_editHelpConfig);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useResetHelpConfig = (onComplete, onError) => _useResetHelpConfigMutation({
    update: (cache, result) => {
        onComplete(result?.data.Actions_resetHelpConfig);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetSmtpQuery = () => {
    const { data, error, loading } = _useGetSmtpQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getSmtp,
    };
};
export const useGetSslQuery = () => {
    const { data, error, loading } = _useGetSslQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getSsl,
    };
};
export const useGetRevSshQuery = () => {
    const { data, error, loading } = _useGetRevSshQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getRevSsh,
    };
};
export const useGetNasQuery = () => {
    const [getNas, { data, error, loading }] = _useGetNasLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getNas,
        error,
        loading,
        data: data?.Admin_getNas,
    };
};
export const useGetSnapshotQuery = () => {
    const [getSnapshot, { data, error, loading }] = _useGetSnapshotLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getSnapshot,
        error,
        loading,
        data: data?.Admin_getSnapshot,
    };
};
export const useSetSmtpMutation = (onComplete, onError, data) => _useSetSmtpMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setSmtp);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetSsl = () => {
    const [_useSetSslMutation, { data, error, loading }] = useMutation(SetSslDocument);
    return {
        error,
        loading,
        data: data?.Admin_setSsl,
        useSetSslMutation: (data) => {
            _useSetSslMutation({
                variables: {
                    data,
                },
            });
        },
    };
};
export const setSsl = (params) => fetch('/managementconsole/admin-api/ssl', {
    method: 'POST',
    body: params,
})
    .then(response => {
    if (!response.ok) {
        response
            .json()
            .then(jsonData => {
            throw new ApolloError({ errorMessage: jsonData });
        })
            .catch(() => _.noop());
    }
    return response.json();
})
    .catch(() => false);
export const useSetRevSshMutation = (onComplete, onError, data) => _useSetRevSshMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setRevSsh);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetNasMutation = (onComplete, onError, data) => _useSetNasMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setNas);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetSnapshotMutation = (onComplete, onError, data) => _useSetSnapshotMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setSnapshot);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useDeleteSmtpMutation = (onComplete, onError) => _useDeleteSmtpMutation({
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteSmtp);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useDeleteSslMutation = (onComplete, onError) => _useDeleteSslMutation({
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteSsl);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useDeleteNasMutation = (onComplete, onError, data) => _useDeleteNasMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteNas);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useDeleteSnapshotMutation = (onComplete, onError, snapshotName) => _useDeleteSnapshotMutation({
    variables: {
        snapshotName,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteSnapshot);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetSamlIamV1Query = ({ skip } = {}) => {
    const { data, error, loading } = _useGetSamlIamV1Query({
        fetchPolicy: 'no-cache',
        skip,
    });
    return {
        error,
        loading,
        data: data?.Admin_getSaml,
    };
};
export const setSaml = (params) => fetch('/managementconsole/admin-api/saml', {
    method: 'POST',
    body: params,
})
    .then(response => {
    if (!response.ok) {
        response
            .json()
            .then(jsonData => {
            throw new ApolloError({ errorMessage: jsonData });
        })
            .catch(() => _.noop());
    }
    return response.json();
})
    .catch(() => false);
export const useDeleteSamlIamV1Mutation = (onComplete, onError) => _useDeleteSamlIamV1Mutation({
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteSaml);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetLocalIamV1Mutation = (onComplete, onError, data) => _useSetLocalIamV1Mutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setLocal);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetLocalIamV1Query = () => {
    const { data, error, loading } = _useGetLocalIamV1Query({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getLocal,
    };
};
export const useGetLdapAdIamV1Query = ({ skip } = {}) => {
    const { data, error, loading } = _useGetLdapAdIamV1Query({
        fetchPolicy: 'no-cache',
        skip,
    });
    return {
        error,
        loading,
        data: data?.Admin_getLdapAd,
    };
};
export const useSetLdapAdIamV1Mutation = (onComplete, onError, data) => _useSetLdapAdIamV1Mutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setLdapAd);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useDeleteLdapAdIamV1Mutation = (onComplete, onError) => _useDeleteLdapAdIamV1Mutation({
    update: (cache, result) => {
        onComplete(result?.data.Admin_deleteLdapAd);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSetActiveDirectory = () => {
    const { data, post, error, loading, response } = useFetch('/managementconsole/admin-api/ldap/configure', {
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        cachePolicy: CachePolicies.NO_CACHE,
    });
    function postLdapAd(inputData) {
        return post('', inputData);
    }
    return {
        error,
        loading,
        postLdapAd,
        response,
    };
};
const getUrl = (endpoint) => {
    const params = endpoint.split('?');
    if (!shouldUseGetEncoding() || params.length === 1) {
        return endpoint;
    }
    const basePath = params.shift();
    const encodedParams = {
        tsb64ue: encodeBase64URLString(params.join('?')),
    };
    const encodedGetParamsString = generateURIParamsString(encodedParams);
    return `${ENCODE_BASE_PATH}/${basePath}?${encodedGetParamsString}`;
};
export const generateRequest = (type, endpoint, config) => {
    const options = {
        method: type,
        headers: config,
    };
    if (type === 'POST' || type === 'UPDATE') {
        const origData = { ...config.data };
        const formData = options.headers['Content-Type'] !==
            'application/x-www-form-urlencoded'
            ? new FormData()
            : new URLSearchParams();
        Object.keys(config.data).forEach(k => {
            formData.append(k, config.data[k]);
        });
        delete options.headers.data;
        Object.assign(options, {
            mode: 'cors',
            body: options.headers['Content-Type'] === 'application/json'
                ? JSON.stringify(origData)
                : formData,
        });
    }
    const urlEndpoint = getUrl(endpoint);
    return new Promise((resolve, reject) => {
        fetch(urlEndpoint, options).then(response => {
            if (!response.ok) {
                return reject(response || new Error('Internal server error has occurred'));
            }
            resolve(response);
        });
    });
};
export const parseData = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str.trim();
    }
};
const getParsedData = async (response) => {
    const data = await response.text();
    return parseData(data);
};
export const postDataService = async (type, endpoint, config) => {
    let response;
    try {
        response = await generateRequest(type, endpoint, config);
    }
    catch (e) {
        throw e;
    }
    return getParsedData(response);
};
export const useCheckSslCertMutation = () => {
    const [_checkSSLCert, { data: result, error, loading }] = useMutation(CheckSslCertDocument);
    return {
        data: result?.Admin_checkSSLCert,
        error,
        loading,
        checkSSLCert: (url) => _checkSSLCert({
            variables: {
                url,
            },
        }),
    };
};
const hasCurrentValue = (value) => {
    return (typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value) &&
        'current' in value);
};
const coercePrimitiveValue = (value) => {
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true') {
            return true;
        }
        if (value.toLowerCase() === 'false') {
            return false;
        }
    }
    return value;
};
const coerceConfigValue = (value) => {
    if (Array.isArray(value)) {
        return value.map(item => coerceConfigValue(item));
    }
    if (value && typeof value === 'object') {
        const coerced = {};
        Object.keys(value).forEach(key => {
            coerced[key] = coerceConfigValue(value[key]);
        });
        return coerced;
    }
    return coercePrimitiveValue(value);
};
const extractMutableValue = (value) => {
    if (hasCurrentValue(value)) {
        return value.current;
    }
    return value;
};
const normalizeConfigOverrides = (data) => {
    const normalized = {};
    Object.keys(data || {}).forEach(key => {
        const normalizedValue = coerceConfigValue(extractMutableValue(data[key]));
        normalized[key] = normalizedValue;
    });
    return normalized;
};
export const getConfigInfoOverrides = async () => {
    const { client } = await import("../../apollo-client");
    const { data } = await client.query({
        query: GetConfigInfoOverridesDocument,
        fetchPolicy: 'no-cache',
    });
    if (data?.Admin_getConfigInfoOverrides?.Error) {
        throw new Error(data.Admin_getConfigInfoOverrides.Error);
    }
    const rawData = data?.Admin_getConfigInfoOverrides?.Data;
    return normalizeConfigOverrides(rawData || {});
};
export const updateConfigInfo = async (changes) => {
    const { client } = await import("../../apollo-client");
    const { data } = await client.mutate({
        mutation: UpdateConfigInfoDocument,
        variables: { changes },
    });
    if (data?.Admin_updateConfigInfo?.Error) {
        throw new Error(data.Admin_updateConfigInfo.Error);
    }
};
export const useGetAdminAlertsQuery = () => {
    const { data, error, loading } = _useGetAdminAlertsQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        data,
        error,
        loading,
    };
};
export const useGetAdminEventsQuery = () => {
    const { data, error, loading } = _useGetAdminEventsQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        data,
        error,
        loading,
    };
};
//# sourceMappingURL=system-service.js.map